
import '../../grower/landDetailsReg/landDetails.css';
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import moment from 'moment';

import { GET_ADDRESS_BY_PINCODE, GET_GROWER_BAMBOO_SPECIES, UPLOAD_DCUMENT, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE, ResourceUpdateMember, VERIFY_GROWER_MOBILE_NUMBER } from '../../../../../common/URLs';
import "react-datepicker/dist/react-datepicker.css";
import { BambooSpeciesPopover } from '../../../../../preregcamps/confirmPopover/bambooSpeciesPopover';
import { ROLES, BASIC_DATE_FORMAT, API_DATE_FORMAT, BLOCK_LIST, EMPTY_FIELD_ERROR, LAND_AREA_UNIT, PINCODE_NO_ERROR, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, UPLOAD_FILE_TEXT, LAND_AREA_ERROR, SOURCING } from '../../../../../common/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogContent, IconButton, Dialog } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { VALIDATION, nameValidation, pincodeValidation, typeNumberValid, landAreaValidation, openTextFieldMaxLength } from '../../../../../common/commonValidations';
import { loaderService } from '../../../../../common/custom-loader/loader-service';
import Preview from '../../../registration/preview';
import jwt from 'jwt-decode';
import { FileUploadMUI } from '../../../../../common/fileUpload/fileUploadMUI';
import { getLocalStorageItem } from '../../../../../common/localStorageUtils';
import { PROD } from '../../../../../common/constants';
import { Button, Switch, Collapse, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { CommonPincodeMUI } from '../../../../../common/common-pincode/commonPincodeMUI';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { LocationPointMUI } from '../../../../../common/locationPoints/locationPointMUI';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../../../common/customDataGridToolbar';
import { Add as AddIcon, Clear as CancelIcon, Send as SendIcon, Done as ApproveIcon, Visibility as ViewIcon, ArrowForwardIosSharp as AccordionIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { getBambooSpecies } from '../../../../../common/Utils';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationPopover } from '../../../../../common/commonPopovers/confirmationPopover';
import { useGrowerMemberContextData } from "../registrationMemberDetails";
import { toast } from 'react-toastify';
import { insertComment } from '../../commonRegistrationStakeholderAPIs';
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from '../../../../../common/commonFunction';
import { Tooltip, } from '@mui/material';
import { CloseIcon, EditIcon, SaveIcon, UpdateIcon } from '../../../../../common/icons';
import apiClient from '../../../../../axios';
import CommentIcon from '@mui/icons-material/Comment';

const MemberLandDetails = ({ }) => {
    const { stakeHolderDetails, memberDetails, setMemberDetails, expandedSection, setExpandedSection, errorMessage, setErrorMessage, setNewLandComments, setLandDetailsSectionOk, personallandUpdatedDetails, setPersonallandUpdatedDetails, enableFieldFunction, shouldActOnSectionLand, setShouldActOnSectionLand, landUpdatedDetails, setLandUpdatedDetails, setMemberDetailArray, memberDetailArray, onAddNewMemberDetails, onEditMemberDetailsCallback, growerDetails, setCallUpdateApi, newLandArray, setNewLandArray, showCommentSection, landDetailsSectionOk, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, comments, setComments, setCommentsData, viewOnly, userType, regScruResourceUpdate, setRegScruResourceUpdate } = useGrowerMemberContextData();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const uuid = localStorage.getItem('uuid');
    const [characterLimit] = useState(300);
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [bambooSpecies, setBambooSpecies] = useState();
    const [bambooSpeciesRes, setBambooSpeciesRes] = useState();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [landComment, setLandComment] = useState("");
    const [showGridSection, setShowGridSection] = useState(true);
    const [showLandection, setShowLandSection] = useState(false);
    const [showAddMemberSection, setShowAddMemberSection] = useState(false);
    const [newLandObject, setNewLandObject] = useState([]);
    const [addEditBtnName, setAddEditBtnName] = useState('');
    const [addEditMemberBtnName, setAddEditMemberBtnName] = useState('');
    const [hidden, setHidden] = useState({
        divPreview: true
    });
    const [captiveStartDateDisplay, setCaptiveStartDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [captiveEndDateDisplay, setCaptiveEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [leaseStartDateDisplay, setLeaseStartDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [leaseEndDateDisplay, setLeaseEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [landAreaValue, setLandAreaValue] = useState();
    const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [availableLandAreaValue, setAvailableLandAreaValue] = useState();
    const [availableLandAreaUnit, setAvailableLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [selectedLand, setSelectedLand] = useState();
    const [selectedLandId, setSelectedLandId] = useState();
    const [selectedMemberContact, setSelectedMemberContact] = useState();
    const [growerLandDetails, setGrowerLandDetails] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalYes, setLogModalYes] = useState(false);
    const [editSpecies, setEditSpecies] = useState();
    const [speciesName, setSpeciesName] = useState();
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const handleLogModalYes = () => setLogModalYes(true);
    const handleConfirmLogModalClose = () => setLogModalYes(false);
    const [loc, setLoc] = useState();
    // Split into positioned and unpositioned
    const sortedMembers = memberDetailArray?.sort((a, b) => b?.sequence - a?.sequence); // Descending
    console.log("sortedMembers", sortedMembers)
    const [open, setOpen] = useState(() => {
        const initialState = {};
        memberDetailArray.forEach(memberItem => {
            memberItem?.growerCoopLandDetails?.forEach(obj => {
                initialState[obj.id] = false;
            });
        })
        return initialState;
    });

    useEffect(() => {
        getBambooSpecies(bambooCallback);
    }, [])

    const bambooCallback = (response) => {
        setBambooSpeciesRes(response)
    }
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setLoc(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);

    let updatedGrowerLandDetail =
    {
        "id": growerLandDetails?.id,
        "regGrowerMemberId": growerLandDetails?.regGrowerMemberId,
        "pincode": landUpdatedDetails?.pincode,
        "address": landUpdatedDetails?.address,
        "state": landUpdatedDetails?.state,
        "district": landUpdatedDetails?.district,
        "subDivision": landUpdatedDetails?.subDivision,
        "postOffice": growerLandDetails?.postOffice,
        "revenueCircle": landUpdatedDetails?.revenueCircle,
        "blockName": landUpdatedDetails?.blockName,
        "captive": landUpdatedDetails.captive,
        "captiveStartDate": landUpdatedDetails?.captiveStartDate ? landUpdatedDetails?.captiveStartDate : moment(new Date()).format(API_DATE_FORMAT),
        "captiveEndDate": landUpdatedDetails?.captiveEndDate ? landUpdatedDetails?.captiveEndDate : moment(new Date()).format(API_DATE_FORMAT),
        "landArea": landAreaValue + " " + landAreaUnit,
        "availableLandArea": availableLandAreaValue + " " + availableLandAreaUnit,
        "totalNoOfBambooClumps": growerLandDetails?.totalNoOfBambooClumps,
        "landLeasedOwned": landUpdatedDetails?.landLeasedOwned ? landUpdatedDetails?.landLeasedOwned : 'Leased',
        "leaseStartDate": landUpdatedDetails?.leaseStartDate ? landUpdatedDetails?.leaseStartDate : moment(new Date()).format(API_DATE_FORMAT),
        "leaseEndDate": landUpdatedDetails?.leaseEndDate ? landUpdatedDetails?.leaseEndDate : moment(new Date()).format(API_DATE_FORMAT),
        "isPreregistrationShortlisted": growerLandDetails?.isPreregistrationShortlisted,
        "easeOfSourcing": landUpdatedDetails?.easeOfSourcing,
        "sidingRequirement": landUpdatedDetails?.sidingRequirement,
        "sidingDistanceInMtrs": landUpdatedDetails?.sidingDistanceInMtrs,
        "landType": landUpdatedDetails?.landType ? landUpdatedDetails?.landType : 'Hill',
        "landName": landUpdatedDetails?.landName ? landUpdatedDetails?.landName : '',
        "cooperativeName": growerLandDetails?.cooperativeName,
        "cooperativeOwner": growerLandDetails?.cooperativeOwner,
        "coopLandLocation": growerLandDetails?.coopLandLocation,
        "govtAgencyName": growerLandDetails?.govtAgencyName,
        "govtAgencyIncharge": growerLandDetails?.govtAgencyIncharge,
        "locationGeocode": growerLandDetails?.locationGeocode,
        "createdOn": growerLandDetails?.createdOn,
        "createdBy": growerLandDetails?.createdBy,
        "updatedOn": growerLandDetails?.updatedOn,
        "updatedBy": growerLandDetails?.updatedBy,
        "isActive": 1,
        "growerCoopBambooSpecies": landUpdatedDetails?.growerCoopBambooSpecies,
        "growerCoopLandDocuments": landUpdatedDetails?.growerCoopLandDocuments,
        "geocodeLattitude": landUpdatedDetails?.geocodeLattitude,
        "geocodeLongitude": landUpdatedDetails?.geocodeLongitude
    }

    let userRole = localStorage.getItem('role');
    useEffect(() => {
        getGrowerBambooSpecies();
    }, []);
    const onUploadCallBack = (docArray) => {

        setLandUpdatedDetails({ ...landUpdatedDetails, growerCoopLandDocuments: docArray });
        var landDocument = docArray.filter((item) => item.documentType === "LandLeasedOwned" && (item.isActive == 1 || item.isActive === 3));
        if (landDocument?.length > 0) {
            setErrorMessage({ errorMessage, landDocumentError: "" });
        }
    }
    const addLandBtnClick = () => {
        if (validateLandDetails()) {
            addEditBtnName === t('reg.addland') ? addLandCallback(updatedGrowerLandDetail, comments) : editLandCallback(updatedGrowerLandDetail)
            setShowGridSection(true);
            setShowLandSection(false);
        }
    }
    const addLandCallback = (landUpdatedDetails, comments) => {
        setNewLandComments(comments.filter((item) => item.type === "New Land"))
        newLandArray?.push(landUpdatedDetails);
        let memberDetail = memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === selectedMemberContact)[0];
        memberDetail.growerCoopLandDetails = newLandArray;
        let remaingArr = memberDetailArray?.filter(obj => obj?.contact !== selectedMemberContact);
        remaingArr.push(memberDetail);
        setMemberDetailArray(remaingArr);
        setNewLandObject([]);
        // enableSaveSubmitButtons && setCallUpdateApi(true);
        setCallUpdateApi(true);
    }
    const deleteLandCallback = (landArray, contactNo) => {
        setNewLandArray(landArray);
        let memberDetail = memberDetailArray && memberDetailArray?.find(obj => obj?.contact === contactNo);
        memberDetail.growerCoopLandDetails = landArray;
        let remaingMemberArr = memberDetailArray?.filter(obj => obj?.contact !== contactNo);
        remaingMemberArr.push(memberDetail);
        setMemberDetailArray(remaingMemberArr);
    }
    const editLandCallback = (landUpdatedDetails) => {
        const remainingArr = newLandArray?.filter((item, index) => item.landName !== landUpdatedDetails.landName);
        remainingArr.push(landUpdatedDetails);
        setNewLandArray(remainingArr);
        let memberDetail = memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === selectedMemberContact)[0];
        memberDetail.growerCoopLandDetails = remainingArr;
        let remaingMemberArr = memberDetailArray?.filter(obj => obj?.contact !== selectedMemberContact);
        remaingMemberArr.push(memberDetail);
        setMemberDetailArray(remaingMemberArr);
        setOpen((prevOpen) => ({
            ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false]))
        }));
        setCallUpdateApi(true);
    }
    const addnewLandBtnClick = (item) => {
        const tempId = "noId"
        newLandObject.length === 0 && setOpen((prevOpen) => ({
            ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
            [tempId]: true
        }));
        setNewLandObject([
            {
                id: tempId,
                pincode: "-",
                landLeasedOwned: "-",
                landType: "-",
                landName: "-",
                growerCoopBambooSpecies: [],
                memberContact: item.contact
            }
        ])
        setGrowerLandDetails('');
        setSelectedLand('');
        setSelectedLandId(uuidv4())
        setLandAreaUnit('sq ft');
        setLandAreaValue('');
        setAvailableLandAreaUnit('sq ft');
        setAvailableLandAreaValue('');
        setLeaseStartDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setLeaseEndDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setCaptiveStartDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setCaptiveEndDateDisplay(moment(new Date()).format(BASIC_DATE_FORMAT));
        setSelectedMemberContact(item?.contact);
        setLandUpdatedDetails({
            ...landUpdatedDetails, address: '',
            pincode: '',
            state: '',
            district: '',
            subDivision: '',
            revenueCircle: '',
            blockName: '',
            captive: true,
            captiveStartDate: moment(new Date()).format(API_DATE_FORMAT),
            captiveEndDate: moment(new Date()).format(API_DATE_FORMAT),
            landArea: '',
            landAreaValue: '',
            landAreaUnit: 'sq ft',
            availableLandArea: '',
            availableLandAreaValue: '',
            availableLandAreaUnit: 'sq ft',
            landLeasedOwned: 'Leased',
            leaseStartDate: moment(new Date()).format(API_DATE_FORMAT),
            leaseEndDate: moment(new Date()).format(API_DATE_FORMAT),
            landType: 'Hilly',
            easeOfSourcing: '',
            sidingRequirement: true,
            sidingDistanceInMtrs: '',
            growerCoopBambooSpecies: [],
            regGrowerMasterId: '',
            growerCoopLandDocuments: [],
            landName: '',
            geocodeLattitude: '',
            geocodeLongitude: '',
        });
        setShowGridSection(false);
        setShowLandSection(true);
        setAddEditBtnName(t('reg.addland'));
        setNewLandArray(memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === item?.contact)[0]?.growerCoopLandDetails);

    }
    const addnewMemberBtnClick = (e) => {
        setShowAddMemberSection(true);
        setAddEditMemberBtnName(t('reg.add'))

    }
    const editBtnClick = (item, landItem) => {
        setSelectedMemberContact(item?.contact);
        let landArr = memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === item?.contact)[0]?.growerCoopLandDetails;
        setNewLandArray(landArr);
        setSelectedLand(landItem?.landName);
        setSelectedLandId(landItem?.id);
        let selectedLandDetails = landArr && landArr?.filter(item1 => item1?.landName === landItem?.landName && (item1.isActive == 1 || item1.isActive == 3));
        setGrowerLandDetails(selectedLandDetails[0]);
        setErrorMessage({ landAreaError: "", availableLandArea: "" })
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            address: selectedLandDetails[0]?.address,
            pincode: selectedLandDetails[0]?.pincode,
            state: selectedLandDetails[0]?.state,
            district: selectedLandDetails[0]?.district,
            subDivision: selectedLandDetails[0]?.subDivision,
            revenueCircle: selectedLandDetails[0]?.revenueCircle,
            blockName: selectedLandDetails[0]?.blockName,
            captive: selectedLandDetails[0]?.captive,
            captiveStartDate: selectedLandDetails[0]?.captiveStartDate ? selectedLandDetails[0]?.captiveStartDate : moment(new Date()).format(API_DATE_FORMAT),
            captiveEndDate: selectedLandDetails[0]?.captiveEndDate ? selectedLandDetails[0]?.captiveEndDate : moment(new Date()).format(API_DATE_FORMAT),
            landArea: selectedLandDetails[0]?.landArea,
            availableLandArea: selectedLandDetails[0]?.availableLandArea,
            landLeasedOwned: selectedLandDetails[0]?.landLeasedOwned ? selectedLandDetails[0]?.landLeasedOwned : 'Leased',
            leaseStartDate: selectedLandDetails[0]?.leaseStartDate ? selectedLandDetails[0]?.leaseStartDate : moment(new Date()).format(API_DATE_FORMAT),
            leaseEndDate: selectedLandDetails[0]?.leaseEndDate ? selectedLandDetails[0]?.leaseEndDate : moment(new Date()).format(API_DATE_FORMAT),
            landType: selectedLandDetails[0]?.landType ? selectedLandDetails[0]?.landType : 'Hill',
            landName: selectedLandDetails[0]?.landName ? selectedLandDetails[0]?.landName : '',
            easeOfSourcing: selectedLandDetails[0]?.easeOfSourcing,
            sidingRequirement: selectedLandDetails[0]?.sidingRequirement,
            sidingDistanceInMtrs: selectedLandDetails[0]?.sidingDistanceInMtrs,
            growerCoopBambooSpecies: selectedLandDetails[0]?.growerCoopBambooSpecies ? selectedLandDetails[0]?.growerCoopBambooSpecies : [],
            landDetailsId: selectedLandDetails[0]?.id,
            growerCoopLandDocuments: selectedLandDetails[0]?.growerCoopLandDocuments,
            geocodeLattitude: selectedLandDetails[0]?.geocodeLattitude,
            geocodeLongitude: selectedLandDetails[0]?.geocodeLongitude,
        })
        const spaceIndex = selectedLandDetails[0]?.landArea?.indexOf(" ");
        const numberPart = selectedLandDetails[0]?.landArea?.slice(0, spaceIndex);
        const unitPart = selectedLandDetails[0]?.landArea?.slice(spaceIndex + 1);
        const availableLandSpaceIndex = selectedLandDetails[0]?.availableLandArea?.indexOf(" ");
        const availableLandNumberPart = selectedLandDetails[0]?.availableLandArea?.slice(0, availableLandSpaceIndex);
        const availableLandUnitPart = selectedLandDetails[0]?.availableLandArea?.slice(availableLandSpaceIndex + 1);
        setLandAreaValue(numberPart);
        setLandAreaUnit(unitPart);
        setAvailableLandAreaValue(availableLandNumberPart);
        setAvailableLandAreaUnit(availableLandUnitPart);

        setCaptiveStartDateDisplay(selectedLandDetails[0]?.captiveStartDate ? moment(selectedLandDetails[0]?.captiveStartDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setCaptiveEndDateDisplay(selectedLandDetails[0]?.captiveEndDate ? moment(selectedLandDetails[0]?.captiveEndDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setLeaseStartDateDisplay(selectedLandDetails[0]?.leaseStartDate ? moment(selectedLandDetails[0]?.leaseStartDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))
        setLeaseEndDateDisplay(selectedLandDetails[0]?.leaseEndDate ? moment(selectedLandDetails[0]?.leaseEndDate).format(BASIC_DATE_FORMAT) : moment(new Date()).format(BASIC_DATE_FORMAT))

        setShowGridSection(false);
        setShowLandSection(true);
        setAddEditBtnName(t('reg.updateLand'));


    }

    const handleChange = (e) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails, [e.target.name]: e.target.value
        });
        if (e.target.name === "pincode") {
            if (e.target.value?.length !== 6) {
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            } else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
        else if (e.target.name === 'landName') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
            if (e.target.value?.length > 0) {
                if (newLandArray?.some(item => e.target.value === item.landName && item.isActive == 1)) {
                    setErrorMessage({ ...errorMessage, landNameError: "Land name already exist" });
                } else {
                    setErrorMessage({ ...errorMessage, landNameError: '' });
                }
            } else setErrorMessage({ ...errorMessage, landNameError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === 'address') {
            if (e.target.value?.length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" });
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) });
            } else setErrorMessage({ ...errorMessage, addressError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === 'sidingDistanceInMtrs') {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value.slice(0, 5) })
            if (e.target.value?.length > 0) {
                setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value.slice(0, 5) })
                setErrorMessage({ ...errorMessage, sidingDistanceInMtrsError: "" });
            } else setErrorMessage({ ...errorMessage, sidingDistanceInMtrsError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === "landAreaValue") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setLandAreaValue(slicedLandArea);
            if (slicedLandArea?.length == 0) {
                setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, landAreaError: "" });
            setLandUpdatedDetails({ ...landUpdatedDetails, "landArea": slicedLandArea + ' ' + landAreaUnit });
        }
        else if (e.target.name === "landAreaUnit") {
            setLandAreaUnit(e.target.value);
            setLandUpdatedDetails({ ...landUpdatedDetails, "landArea": landAreaValue + ' ' + e.target.value });
        }
        else if (e.target.name === "availableLandAreaValue") {
            var slicedAvailableLandArea = landAreaValidation(e.target.value);
            setAvailableLandAreaValue(slicedAvailableLandArea);
            if (slicedAvailableLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, availableLandAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, availableLandAreaError: "" });
            setLandUpdatedDetails({ ...landUpdatedDetails, "availableLandArea": slicedAvailableLandArea + ' ' + availableLandAreaUnit });
        }
        else if (e.target.name === "availableLandAreaUnit") {
            setAvailableLandAreaUnit(e.target.value);
            setLandUpdatedDetails({ ...landUpdatedDetails, "availableLandArea": availableLandAreaValue + ' ' + e.target.value });
        }
        else {
            setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: e.target.value })
        }
    };

    const handleMemberChange = (e) => {
        setMemberDetails({ ...memberDetails, [e.target.name]: e.target.value });
        if (e.target.name === 'name') {
            setMemberDetails({ ...memberDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) });
        }

        if (e.target.name === 'contact') {
            setMemberDetails({ ...memberDetails, [e.target.name]: e.target.value.slice(0, 10) })
            if ((e.target.value)?.length < 10) {
                setErrorMessage({ ...errorMessage, memberContactError: 'Please enter 10 digit mobile number' })
            } else setErrorMessage({ ...errorMessage, memberContactError: '' })
        }

    }
    const addUpdateMemberDetails = (e) => {
        if (memberDetails?.name?.length == 0) {
            setErrorMessage({ ...errorMessage, memberNameError: 'Please enter member name' })
            return;
        }
        else {
            setErrorMessage({ ...errorMessage, memberNameError: '' })
        }
        if (memberDetails?.contact?.length == 10) {
            setErrorMessage({ ...errorMessage, memberContactError: '' })
            if (addEditMemberBtnName === t('reg.add')) {
                if (memberDetailArray.filter((item) => item?.contact == memberDetails?.contact)?.length > 0) {
                    setErrorMessage({ ...errorMessage, memberContactError: 'Member with same contact number already exists' })
                    return;
                }
                else {
                    verifyGrowerContact();
                    // onAddNewMemberDetails(memberDetails);
                }
            }
            else {
                onEditMemberDetailsCallback(memberDetails);
            }
            // setShowAddMemberSection(false);
            // setMemberDetails(null);
        }
        else {
            setErrorMessage({ ...errorMessage, memberContactError: 'Please enter valid contact number' })
            return;
        }

    }
    const onEditMemberDetails = (selectedItem) => {
        setShowAddMemberSection(true);
        setAddEditMemberBtnName(t('reg.update'));
        setMemberDetails({ ...memberDetails, ['name']: selectedItem.name, ['contact']: selectedItem.contact });
    }
    const radioChange = (e, value) => {
        setLandUpdatedDetails({ ...landUpdatedDetails, [e.target.name]: value })
    };
    const handleDateChange = (e, name) => {
        // e.preventDefault();
        let date = e.format("YYYY-MM-DD");
        let formattedDate = moment(date).format(API_DATE_FORMAT)
        setLandUpdatedDetails({ ...landUpdatedDetails, [name]: formattedDate })
        if (name == "captiveStartDate")
            setCaptiveStartDateDisplay(date);
        else if (name == "captiveEndDate")
            setCaptiveEndDateDisplay(date);
        else if (name == "leaseStartDate")
            setLeaseStartDateDisplay(date);
        else if (name == "leaseEndDate")
            setLeaseEndDateDisplay(date);
    }
    const bambooSpeciesSubmitCallbackFunction = (bambooSpeciesDetails, onClose) => {
        const remainingArr = bambooSpecies && (landUpdatedDetails?.growerCoopBambooSpecies)?.filter(item => item.bambooSpecies !== bambooSpeciesDetails.bambooSpecies || item.otherBambooSpecies !== bambooSpeciesDetails.otherBambooSpecies);
        remainingArr?.push(bambooSpeciesDetails);
        setLandUpdatedDetails({ ...landUpdatedDetails, growerCoopBambooSpecies: remainingArr })
        onClose();
    }

    const addBamboo = (e, selectedSpecies, otherSpeciesName) => {
        setEditSpecies(selectedSpecies)
        setSpeciesName(otherSpeciesName)
        handleLogModalOpen();
    }

    const onDeleteLand = (memberItem, landItem) => {
        setNewLandArray(memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === memberItem?.contact)[0]?.growerCoopLandDetails)
        setSelectedMemberContact(memberItem?.contact);
        const tempArr = (memberDetailArray && memberDetailArray?.filter(obj => obj?.contact === memberItem?.contact)[0]?.growerCoopLandDetails?.map(item => {
            if (item.landName === landItem.landName) {
                item.isActive = 0
            }
            return item
        }
        ))
        deleteLandCallback(tempArr, memberItem?.contact);

    };

    const onDeleteMemberDetails = (selectedMember) => {
        const tempArr = (memberDetailArray?.map(item => {
            if (item.contact === selectedMember.contact) {
                item.isActive = 0
            }
            return item
        }
        ))
        setMemberDetailArray(tempArr);
    };

    const onLocationPoint = (position) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            geocodeLattitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
            geocodeLongitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
        });
        setErrorMessage({ latitudesError: "", longitudesError: "" })

    }

    const onDeleteSpecies = (id) => {
        const updatedBambooSpecies = ((landUpdatedDetails.growerCoopBambooSpecies).map(item => {
            if (item.bambooSpecies === id) {
                item.isActive = 0
            }
            return item
        }
        ))
        setLandUpdatedDetails({ ...landUpdatedDetails, growerCoopBambooSpecies: updatedBambooSpecies });
    };
    const validateLandDetails = () => {
        if (!landUpdatedDetails?.address || landUpdatedDetails?.address?.length == 0) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter address" });
            toast.error("Please enter address");
            return false;
        }
        else if (!landUpdatedDetails.pincode) {
            setErrorMessage({ pincodeError: "Please enter pincode" });
            toast.error("Please enter pincode");
            return false;
        }
        else if (landUpdatedDetails.pincode?.length !== 6) {
            setErrorMessage({ pincodeError: "Please enter a valid pincode" });
            toast.error("Please enter a valid pincode");
            return false;
        }
        else if (!landUpdatedDetails.state || landUpdatedDetails.state.length == 0) {
            setErrorMessage({ pincodeError: "Please search pincode" });
            toast.error("Please search pincode");
            return false;
        }
        else if (landUpdatedDetails.captive && !landUpdatedDetails.captiveStartDate) {
            setErrorMessage({ captiveStartDateError: "Please enter captive start date" });
            toast.error("Please enter captive start date");
            return false;
        }
        else if (landUpdatedDetails.captive && !landUpdatedDetails.captiveEndDate) {
            setErrorMessage({ captiveEndDateError: "Please enter captive end date" });
            toast.error("Please enter captive end date");
            return false;
        }
        else if (landUpdatedDetails.captiveEndDate < landUpdatedDetails.captiveStartDate) {
            setErrorMessage({ captiveEndDateError: "captive end date can not be less than captive start date" });
            toast.error("captive end date can not be less than captive start date");
            return false;
        }
        else if (!landAreaValue) {
            setErrorMessage({ landAreaError: "Please enter land area" });
            toast.error("Please enter land area");
            return false;
        }
        else if (!availableLandAreaValue) {
            setErrorMessage({ availableLandAreaError: "Please enter available land area" });
            toast.error("Please enter available land area");
            return false;
        }
        else if (availableLandAreaValue == 0 && landAreaValue == 0) {
            setErrorMessage({ availableLandAreaError: "Either existing land area or avilable land area should be greater than 0" });
            toast.error("Either existing land area or avilable land area should be greater than 0");
            return false;
        }
        //else if (landAreaUnit !== availableLandAreaUnit) {
        //    setErrorMessage({ landAreaError: "Please select the same unit for both existing and available land area.", availableLandAreaError: "Please select the same unit for both existing and available land area." });
        //    toast.error("Please select the same unit for both existing and available land area.");
        //    return false;
        //}
        //else if (Number(landAreaValue) < Number(availableLandAreaValue)) {
        //    setErrorMessage({ landAreaError: "Existing land area should be greater than available land area" });
        //    toast.error("Existing land area should be greater than available land area");
        //    return false;
        //}
        else if (landUpdatedDetails?.landLeasedOwned === "Leased" && !landUpdatedDetails.leaseStartDate) {
            setErrorMessage({ leaseStartDateError: "Please enter lease start date" });
            toast.error("Please enter lease start date");
            return false;
        }
        else if (landUpdatedDetails?.landLeasedOwned === "leased" && !landUpdatedDetails.leaseEndDate) {
            setErrorMessage({ leaseEndDateError: "Please enter lease end date" });
            toast.error("Please enter lease end date");
            return false;
        }
        else if (landUpdatedDetails.leaseEndDate < landUpdatedDetails.leaseStartDate) {
            setErrorMessage({ leaseEndDateError: "End date can not be less than lease start date" });
            toast.error("End date can not be less than lease start date");
            return false;
        }
        else if (landUpdatedDetails.leaseStartDate && landUpdatedDetails.leaseEndDate && landUpdatedDetails.captiveStartDate && landUpdatedDetails.captiveEndDate
            && landUpdatedDetails.captiveStartDate < landUpdatedDetails.leaseStartDate) {
            setErrorMessage({ captiveEndDateError: "Captive land agreement start date should be greater than Leased Land Agreement start date" })
            toast.error("Captive land agreement start date should be greater than Leased Land Agreement start date");
            return false;
        }
        else if (!landUpdatedDetails.landName || landUpdatedDetails.landName.length == 0) {
            setErrorMessage({ landNameError: "Please enter land name" })
            toast.error("Please enter land name");
            return false;
        }
        else if (newLandArray.filter(item => landUpdatedDetails.landName === item.landName && item.isActive == 1).length > 0 && updatedGrowerLandDetail.id == null) {
            setErrorMessage({ ...errorMessage, landNameError: "Land name already exist" });
            toast.error("Land name already exist");
            return false;
        }
        else if (!landUpdatedDetails.easeOfSourcing || landUpdatedDetails.easeOfSourcing.length == 0) {
            setErrorMessage({ easeOfSourcingError: "Please select ease of sourcing." })
            toast.error("Please select ease of sourcing.");
            return false;
        }
        else if (landUpdatedDetails?.sidingRequirement && (!landUpdatedDetails?.sidingDistanceInMtrs || landUpdatedDetails.sidingDistanceInMtrs.length == 0)) {
            setErrorMessage({ sidingDistanceInMtrsError: "Please enter siding distance" })
            toast.error("Please enter siding distance");
            return false;
        }
        else if (!decoded.extension_URN && !landUpdatedDetails?.geocodeLattitude) {
            setErrorMessage({ latitudesError: "Please enter latitude" })
            toast.error("Please enter latitude");
            return false;
        }
        else if (!decoded.extension_URN && !landUpdatedDetails?.geocodeLongitude) {
            setErrorMessage({ longitudesError: "Please enter longitude" })
            toast.error("Please enter longitude");
            return false;
        }
        // var landDoc = landUpdatedDetails?.growerCoopLandDocuments && landUpdatedDetails?.growerCoopLandDocuments.filter((item) => item.documentType === "LandLeasedOwned" && item.isActive === 1);
        // if (landDoc?.length === 0) {
        //     setErrorMessage({ landDocumentError: "Please upload grower land documents" });
        //     toast.error("Please upload grower land documents");
        //     return false;
        // }
        // var landPic = landUpdatedDetails?.growerCoopLandDocuments && landUpdatedDetails?.growerCoopLandDocuments.filter((item) => item.documentType === "LandPics" && item.isActive === 1);
        // if (landPic?.length === 0) {
        //     setErrorMessage({ landPicError: "Please upload land image" });
        //     toast.error("Please upload land image");
        //     return false;
        // }
        if (showCommentSection && !comments.find((item) => item.sectionName === "land_details" && item.sectionId === selectedLandId && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
            toast.error("Please enter comments for required sections");
            toast.error("Please enter comments for required sections");
            return false
        }
        return true;
    }
    const getUpdatedAddressData = (data) => {
        setLandUpdatedDetails({
            ...landUpdatedDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
    }
    function getGrowerBambooSpecies() {
        loaderService.showLoader();
        apiClient
            .post(GET_GROWER_BAMBOO_SPECIES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setBambooSpecies(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    const onClickPreviousLandBtn = (e) => {
        e.preventDefault();
        setShowGridSection(true);
        setShowLandSection(false);
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setLandUpdatedDetails({ ...landUpdatedDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setLandUpdatedDetails({ ...landUpdatedDetails, revenueCircle: e.target.value, });
        }
    }
    const onSaveComment = (comment) => {
        const commentObject = {
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "land_details",
            sectionId: selectedLandId,
            sectionOk: landDetailsSectionOk[selectedLandId],
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
        }
        const newLandCommentObject = {
            id: uuidv4(),
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "land_details",
            sectionId: selectedLandId,
            sectionOk: landDetailsSectionOk[selectedLandId],
            userRole: localStorage.getItem('role'),
            type: "New Land",
            landName: !selectedLand ? landUpdatedDetails?.landName : newLandArray.find((item) => item.id === selectedLandId),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
            createdByName: comments?.find((item) => item.sectionName === "personal_details")?.createdByName,
            createdOnFormatted: moment(new Date()).format("DD-MM-YYYY hh:mm a"),
            workflowStepDetailsId: null
        }
        if (comment) {
            if (!selectedLand) {
                const tempArr = [...comments]
                tempArr.push(newLandCommentObject)
                setComments(tempArr);
            }
            else insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData)
        }
        else toast.error("Please enter comment");
        setLandComment("")
        setErrorMessage({ ...errorMessage, landCommentError: "" });

    }

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const columns = [
        {
            field: 'speciesType',
            headerName: t('reg.speciesType'),
            width: 130,
            renderCell: params => (bambooSpeciesRes?.filter(a => a.id === params.row.bambooSpecies)[0].value) + (params.row.otherBambooSpecies ? " - " + params.row.otherBambooSpecies : "")
        },
        {
            field: 'noOfClumps',
            headerName: t('reg.noOfClumps'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgClumpSize',
            headerName: t('reg.avgClumpSize'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgPoleWeight',
            headerName: t('reg.avgWeightOfBambooPole'),
            width: 170,
            type: "number"
        },
        //{
        //    field: 'otherBambooSpecies',
        //    headerName: t('reg.speciesName'),
        //    width: 130
        //},
        {
            field: 'totalQuantity',
            headerName: t('reg.totalBambooQuantity'),
            width: 150,
            type: "number",
            renderCell: params => (params.row.noOfClumps * params.row.avgClumpSize * params.row.avgPoleWeight) / 1000
        },
        {
            field: 'committedNoOfClumps',
            headerName: t('reg.committedQuantity'),
            width: 150
        },
        {
            field: 'actions',
            headerName: t('reg.actions'),
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title="Edit"><IconButton size='small' color="primary" onClick={(e) => addBamboo(e, bambooSpeciesRes?.filter(a => a.id === params.row.bambooSpecies)[0].value, params.row.otherBambooSpecies)}><EditIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete">
                            <IconButton size='small' color="error"
                                onClick={() => onDeleteSpecies(params.row.bambooSpecies, params.row.otherBambooSpecies)} >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },


    ]

    const landColumns = [
        {
            field: 'pincode',
            headerName: t('preReg.pincode'),
            width: 90
        },
        {
            field: 'landLeasedOwned',
            headerName: t('reg.land') + ' ' + t('preReg.owned') + '/' + t('preReg.lease'),
            width: 150
        },
        {
            field: 'landType',
            headerName: t('reg.landType'),
            width: 100
        },
        {
            field: 'landName',
            headerName: t('reg.landName'),
            width: 100
        },
        {
            field: 'bamboo quantity',
            headerName: t('reg.totalBambooQuantity'),
            width: 200,
            renderCell: params => params.row?.growerCoopBambooSpecies.reduce((a, v) => a = a + ((v.noOfClumps * v.avgClumpSize * v.avgPoleWeight) / 1000), 0)

        },
        {
            field: 'commited quantity',
            headerName: t('reg.committedQuantity'),
            width: 190,
            renderCell: params => params.row?.growerCoopBambooSpecies.reduce((a, v) => a = a + ((v.committedNoOfClumps * 1)), 0)
        },
        {
            field: 'view',
            headerName: t('reg.actions'),
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <Button onClick={(e) => editBtnClick(params.row.parent, params.row)} >{t('reg.edit')}</Button>
                        <IconButton size='small' color="error" aria-label="search"
                            onClick={() => onDeleteLand(params.row.parent, params.row)}  >
                            <DeleteIcon />
                        </IconButton>
                    </>
                )
            }
        },
    ]

    function verifyGrowerContact() {
        loaderService.showLoader();
        apiClient
            .post(VERIFY_GROWER_MOBILE_NUMBER,
                {
                    "mobileNumber": memberDetails?.contact
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    setShowAddMemberSection(false);
                    onAddNewMemberDetails(memberDetails);
                    setErrorMessage({ ...errorMessage, memberContactError: '' })
                }
                else {
                    setShowAddMemberSection(true);
                    toast.error(response.data.message)// onAddNewMemberDetails(memberDetails);
                    setErrorMessage({ ...errorMessage, memberContactError: 'Please enter valid contact number' })
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    return (
        <>
            <Grid item xs={12}>
                <Accordion mt={1} expanded={expandedSection === "member"}
                    onChange={(event, expanded) => {
                        setExpandedSection(expanded ? "member" : "");
                    }}>
                    <AccordionSummary sx={{
                        flexDirection: 'row-reverse',
                        backgroundColor: showCommentSection && !regScruResourceUpdate ? (Object.values(landDetailsSectionOk).every(value => value === true) && Object.values(landDetailsSectionOk).length > 0 ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                    }}
                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                    >
                        <Stack ml={2} display="flex" alignItems="center" direction="row">
                            {/* {console.log("landDetailsSectionOk", Object.values(landDetailsSectionOk).length)} */}
                            {showCommentSection && !regScruResourceUpdate && (Object.values(landDetailsSectionOk).every(value => value === true) && Object.values(landDetailsSectionOk).length > 0 ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                            <Typography variant="subtitle1" >Member Details</Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>

                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                {
                                    !showWorkFlowButtons && !showClarificationButton &&
                                    <Button onClick={(e) => addnewMemberBtnClick(e)}
                                        disabled={!enableSaveSubmitButtons || viewOnly}
                                        variant="contained" startIcon={<AddIcon />}>
                                        {t('reg.addNewMember')}
                                    </Button>}
                            </Stack>
                        </Stack>
                        {showAddMemberSection &&
                            <Grid container spacing={2} direction="row" mt={1}>
                                <Grid item xs={12} lg={4}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            type="input"
                                            error={errorMessage.memberNameError}
                                            helperText={errorMessage.memberNameError}
                                            label={t('preReg.name')}
                                            name="name"
                                            value={memberDetails?.name || ''}
                                            onChange={(e) => handleMemberChange(e)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.memberContactError}
                                            helperText={errorMessage.memberContactError}
                                            disabled={addEditMemberBtnName === t('reg.add') ? false : true}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            label={t('main.contact')}
                                            name="contact"
                                            value={memberDetails?.contact || ''}
                                            onChange={(e) => handleMemberChange(e)} />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <Grid item xs={12}>
                                        <Box display='flex' alignItems="center" justifyContent="center" mt={1} style={{ float: "right" }}>
                                            <Button startIcon={<CloseIcon />} sx={{ minWidth: 100, marginRight: "8px" }} variant="outlined" onClick={() => {
                                                setShowAddMemberSection(false);
                                                setMemberDetails(null);
                                                setErrorMessage({ errorMessage, memberNameError: "" });
                                                setErrorMessage({ errorMessage, memberContactError: "" });
                                            }}>Cancel</Button>
                                            <Button startIcon={addEditMemberBtnName === t('reg.update') ? <UpdateIcon /> : <AddIcon />} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => addUpdateMemberDetails(e)}>{addEditMemberBtnName}</Button>
                                        </Box>

                                    </Grid>
                                </Grid>
                            </Grid>}
                        <Grid item xs={12} mt={2}>
                            {sortedMembers.filter((item1) => (item1?.isActive === 1 || item1?.isActive === 3)).map((item, index) =>
                                <Accordion >
                                    <AccordionSummary sx={{
                                        flexDirection: 'row-reverse',
                                        backgroundColor: showCommentSection && !regScruResourceUpdate ? (item.growerCoopLandDetails.every(landObj => landDetailsSectionOk[landObj.id] === true) ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                                    }}
                                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}>
                                        <Stack ml={2} display="flex" alignItems="center" direction="row">
                                             <Typography variant="h6" mr={2}>{item?.sequence}</Typography>
                                            {showCommentSection && !regScruResourceUpdate && (item.growerCoopLandDetails.every(landObj => landDetailsSectionOk[landObj.id] === true) ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                            <Typography variant="subtitle2" >{`Member Name: ${item?.name}  |  Member Contact: ${item?.contact}`}</Typography>
                                        </Stack>
                                        <Stack direction='row' spacing={1} justifyContent="flex-end" >
                                            {!showWorkFlowButtons && !showClarificationButton && <> <Tooltip title="Edit"><IconButton size='small' color="primary" disabled={!enableSaveSubmitButtons || viewOnly} onClick={(e) => onEditMemberDetails(item)} ><EditIcon /></IconButton></Tooltip>
                                                <Tooltip title="Delete">
                                                    <IconButton disabled={!enableSaveSubmitButtons || viewOnly} size='small' color="error" aria-label="search"
                                                        onClick={() => onDeleteMemberDetails(item)}  >
                                                        <DeleteIcon color={!enableSaveSubmitButtons ? 'disabled' : 'error'} fontSize='small' />
                                                    </IconButton></Tooltip></>}
                                        </Stack>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} ml={1} mt={1} justifyContent="flex-end" mb={1}>
                                                {/* <Typography variant="subtitle1" >{t('reg.land details')}</Typography> */}
                                            </Stack>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                                                {!showWorkFlowButtons && !showClarificationButton && <Button onClick={() => addnewLandBtnClick(item)} variant="contained" disabled={!enableSaveSubmitButtons || viewOnly} startIcon={<AddIcon />}>
                                                    {t('reg.addNewLand')}
                                                </Button>}
                                            </Stack>
                                        </Stack>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell >{t('preReg.pincode')}</TableCell>
                                                        <TableCell>{t('reg.land') + ' ' + t('preReg.owned') + '/' + t('preReg.lease')}</TableCell>
                                                        <TableCell>{t('reg.landType')}</TableCell>
                                                        <TableCell>{t('reg.landName')}</TableCell>
                                                        <TableCell>{t('reg.totalBambooQuantity')}</TableCell>
                                                        <TableCell>{t('reg.committedQuantity')}</TableCell>
                                                        <TableCell>{t('reg.actions')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {newLandObject.filter(newLandObjFilterItem => newLandObjFilterItem.memberContact === item.contact).concat(item?.growerCoopLandDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).map((child) => ({ ...child, parent: item }))).map((row) => (
                                                        <>
                                                            <TableRow sx={{
                                                                '& > *': {
                                                                    borderBottom: 'unset',
                                                                    backgroundColor: showCommentSection && !regScruResourceUpdate ? (landDetailsSectionOk[row.id] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                                                                }
                                                            }}>
                                                                <TableCell>
                                                                    <IconButton
                                                                        aria-label="expand row"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen((prevOpen) => ({
                                                                                ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
                                                                                [row.id]: !prevOpen[row.id],
                                                                            }));
                                                                            row.id === "noId" ? addnewLandBtnClick() : editBtnClick(item, row);
                                                                        }}
                                                                    >
                                                                        {open[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                        {showCommentSection && !regScruResourceUpdate && (landDetailsSectionOk[row.id] ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginLeft: "2vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginLeft: "2vh" }} />)}
                                                                    </IconButton>
                                                                </TableCell>
                                                                <TableCell>{row.pincode}</TableCell>
                                                                <TableCell>{row.landLeasedOwned}</TableCell>
                                                                <TableCell>{row.landType}</TableCell>
                                                                <TableCell>{row.landName}</TableCell>
                                                                <TableCell>{row?.growerCoopBambooSpecies.reduce((a, v) => a = a + ((v.noOfClumps * v.avgClumpSize * v.avgPoleWeight) / 1000), 0)}</TableCell>
                                                                <TableCell>{row?.growerCoopBambooSpecies.reduce((a, v) => a = a + ((v.committedNoOfClumps * 1)), 0)}</TableCell>
                                                                <TableCell> <>
                                                                    {/* <Button onClick={(e) => editBtnClick(e, row)}
                                                    >{enableFieldFunction(shouldActOnSectionLand[row.id], false, false) ? "Edit" : "View"}</Button> */}
                                                                    {enableFieldFunction(shouldActOnSectionLand[row.id], false, false) &&
                                                                        <Tooltip title="Delete">
                                                                            <IconButton size='small' color="error" aria-label="search"
                                                                                onClick={() => onDeleteLand(item, row)} >
                                                                                <DeleteIcon color='error' fontSize='small' />
                                                                            </IconButton>
                                                                        </Tooltip>}
                                                                </></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                                                                    <Collapse in={open[row.id]} timeout="auto" unmountOnExit>
                                                                        <Grid container pb={3} pr={4} spacing={2} direction="row" sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (landDetailsSectionOk[selectedLandId] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "105%" }}>
                                                                            <Grid item xs={12} style={{ marginBottom: "1em" }} alignItems="center">
                                                                                <Stack direction="row" alignItems="center">
                                                                                    <Typography variant="h6" mt={3}>
                                                                                        {t('reg.land details')}
                                                                                    </Typography>
                                                                                </Stack>
                                                                            </Grid>
                                                                            <Grid item xs={12} lg={6}>
                                                                                <Grid container spacing={1}>
                                                                                    <Grid item xs={12}>
                                                                                        <TextField fullWidth
                                                                                            required
                                                                                            error={errorMessage.addressError}
                                                                                            helperText={errorMessage.addressError}
                                                                                            type="input"
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            multiline
                                                                                            label={t('main.address')}
                                                                                            name="address"
                                                                                            value={landUpdatedDetails?.address}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                        />
                                                                                    </Grid>
                                                                                    <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                                                                        pincode={landUpdatedDetails?.pincode}
                                                                                        isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                        state={landUpdatedDetails?.state}
                                                                                        district={landUpdatedDetails?.district}
                                                                                        revenueCircle={landUpdatedDetails?.revenueCircle}
                                                                                        blockName={landUpdatedDetails?.blockName}
                                                                                        onHandleCallback={getUpdatedAddressData}
                                                                                        pincodeError={errorMessage.pincodeError}
                                                                                        searchError={errorMessage.searchError}
                                                                                        handleChangeSelect={handleChangeSelect}
                                                                                    />
                                                                                    <Grid item xs={12}>
                                                                                        <Typography variant="subtitle1" gutterBottom>{t('reg.captive')}</Typography>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                            name="row-radio-buttons-group"

                                                                                        >
                                                                                            <FormControlLabel control={<Radio name="captive" value="true" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.captive === true} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                            <FormControlLabel control={<Radio name="captive" value="false" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.captive === false} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />
                                                                                        </RadioGroup>
                                                                                    </Grid>
                                                                                    <Grid item xs={6} hidden={!landUpdatedDetails?.captive}>
                                                                                        <FormControl fullWidth>
                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                <DesktopDatePicker
                                                                                                    //required
                                                                                                    // error={errorMessage.captiveStartDateError}
                                                                                                    // helperText={errorMessage.captiveStartDateError}
                                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                    label={t('reg.startDate')}
                                                                                                    value={captiveStartDateDisplay}
                                                                                                    name="captiveStartDate"
                                                                                                    onChange={(e) => handleDateChange(e, "captiveStartDate")}
                                                                                                    renderInput={(params) => <TextField {...params} />}

                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.captiveStartDateError}</FormHelperText>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                    <Grid item xs={6} hidden={!landUpdatedDetails?.captive}>
                                                                                        <FormControl fullWidth>
                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                <DesktopDatePicker
                                                                                                    required
                                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                    error={errorMessage.captiveEndDateError}
                                                                                                    helperText={errorMessage.captiveEndDateError}
                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                    minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                                                                    value={captiveEndDateDisplay}
                                                                                                    label={t('reg.endDate')}
                                                                                                    name="captiveEndDate"
                                                                                                    onChange={(e) => handleDateChange(e, "captiveEndDate")}
                                                                                                    renderInput={(params) => <TextField {...params} />}

                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.captiveEndDateError}</FormHelperText>
                                                                                            {captiveEndDateDisplay < moment(new Date()).format(BASIC_DATE_FORMAT) && <FormHelperText sx={{ color: 'red' }}>End date has already passed</FormHelperText>}
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <TextField fullWidth
                                                                                            required
                                                                                            error={errorMessage.landAreaError}
                                                                                            helperText={errorMessage.landAreaError}
                                                                                            type="number"
                                                                                            onFocus={handleNumberFieldFocus}
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            label={t('preReg.existingLandArea')}
                                                                                            name="landAreaValue"
                                                                                            value={landAreaValue}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                            InputProps={{
                                                                                                endAdornment: (
                                                                                                    <Select
                                                                                                        variant="standard"
                                                                                                        size="small"
                                                                                                        name="landAreaUnit"
                                                                                                        disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                        value={landAreaUnit}
                                                                                                        onChange={(e) => handleChange(e)}>
                                                                                                        {LAND_AREA_UNIT.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                                                                    </Select>
                                                                                                ),
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <TextField fullWidth
                                                                                            required
                                                                                            error={errorMessage.availableLandAreaError}
                                                                                            helperText={errorMessage.availableLandAreaError}
                                                                                            type="number"
                                                                                            onFocus={handleNumberFieldFocus}
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            label={t('preReg.availableLandArea')}
                                                                                            name="availableLandAreaValue"
                                                                                            value={availableLandAreaValue}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                            InputProps={{
                                                                                                endAdornment: (
                                                                                                    <Select
                                                                                                        variant="standard"
                                                                                                        size="small"
                                                                                                        name="availableLandAreaUnit"
                                                                                                        disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                        value={availableLandAreaUnit}
                                                                                                        onChange={(e) => handleChange(e)}>
                                                                                                        {LAND_AREA_UNIT.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                                                                    </Select>
                                                                                                ),
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Typography variant="subtitle1" gutterBottomLand>{t('reg.land')}</Typography>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                            name="row-radio-buttons-group"
                                                                                        >
                                                                                            <FormControlLabel value="Leased" control={<Radio name="landLeasedOwned" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.landLeasedOwned === "Leased"} onChange={(e) => handleChange(e)} />} label={t('preReg.lease')} />
                                                                                            <FormControlLabel value="Owned" control={<Radio name="landLeasedOwned" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.landLeasedOwned === "Owned"} onChange={(e) => handleChange(e)} />} label={t('preReg.owned')} />
                                                                                        </RadioGroup>
                                                                                    </Grid>
                                                                                    <Grid item xs={6} hidden={landUpdatedDetails?.landLeasedOwned === "Owned"}>
                                                                                        <FormControl fullWidth>
                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                <DesktopDatePicker
                                                                                                    // required
                                                                                                    // error={errorMessage.leaseStartDateError}
                                                                                                    // helperText={errorMessage.leaseStartDateError}
                                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                    label={t('reg.startDate')}
                                                                                                    value={leaseStartDateDisplay}
                                                                                                    onChange={(e) => handleDateChange(e, "leaseStartDate")}
                                                                                                    renderInput={(params) => <TextField {...params} />}

                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.leaseStartDateError}</FormHelperText>
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                    <Grid item xs={6} hidden={landUpdatedDetails?.landLeasedOwned === "Owned"}>
                                                                                        <FormControl fullWidth>
                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                <DesktopDatePicker
                                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                    // required
                                                                                                    // error={errorMessage.leaseEndDateError}
                                                                                                    // helperText={errorMessage.leaseEndDateError}
                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                    renderInput={(params) => <TextField {...params} />}
                                                                                                    sx={{ paddingRight: '3%' }}
                                                                                                    value={leaseEndDateDisplay}
                                                                                                    label={t('reg.endDate')}
                                                                                                    minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                                                                    onChange={(e) => handleDateChange(e, "leaseEndDate")}
                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.leaseEndDateError}</FormHelperText>
                                                                                            {leaseEndDateDisplay < moment(new Date()).format(BASIC_DATE_FORMAT) && <FormHelperText sx={{ color: 'red' }}>End date has already passed</FormHelperText>}
                                                                                        </FormControl>
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <FileUploadMUI key="LandLeasedOwned"
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                            documentList={landUpdatedDetails?.growerCoopLandDocuments}
                                                                                            documentType="LandLeasedOwned"
                                                                                            callBackDocumentUpload={onUploadCallBack}
                                                                                            stakeholderDetailId={growerDetails?.growers[0]?.growerLandDetails[0]?.id}
                                                                                            title={landUpdatedDetails?.landLeasedOwned === "Owned" ? t('reg.uploadRelevantDOc') : t('reg.leaseAgreement')}
                                                                                            stakeHolderType="grower"
                                                                                            errorMessage={errorMessage}
                                                                                            setErrorMessage={setErrorMessage}
                                                                                            documentError="landDocumentError"
                                                                                        />
                                                                                        {/* <div className='mandatory_field'>{errorMessage.landDocumentError}</div> */}
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <Grid item xs={12} lg={6}>
                                                                                <Grid container spacing={1}>
                                                                                    <Grid item xs={12}>
                                                                                        <TextField fullWidth
                                                                                            required
                                                                                            error={errorMessage.landNameError}
                                                                                            disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true) || (addEditBtnName === t('reg.updateLand')) ? true : false}
                                                                                            helperText={errorMessage.landNameError}
                                                                                            name="landName"
                                                                                            value={landUpdatedDetails?.landName}
                                                                                            label={t('reg.landName')}
                                                                                            onChange={(e) => handleChange(e)}
                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Typography variant="subtitle1" gutterBottom>{t('reg.landType')}</Typography>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                            name="row-radio-buttons-group"
                                                                                        >
                                                                                            <FormControlLabel value="Hilly" control={<Radio className='label_grower_reg' name="landType" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.landType === "Hilly"} onChange={(e) => handleChange(e)} />} label={t('reg.hilly')} />
                                                                                            <FormControlLabel value="Plain" control={<Radio className='label_grower_reg' name="landType" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.landType === "Plain"} onChange={(e) => handleChange(e)} />} label={t('reg.plain')} />
                                                                                            <FormControlLabel value="Trench" control={<Radio className='label_grower_reg' name="landType" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.landType === "Trench"} onChange={(e) => handleChange(e)} />} label={t('reg.trench')} />
                                                                                        </RadioGroup>
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Tooltip title="Difficulty in harvesting and transportation" arrow>
                                                                                            <FormControl fullWidth>
                                                                                                <InputLabel>{t('reg.easeOfSourcing')}</InputLabel>
                                                                                                <Select
                                                                                                    required
                                                                                                    error={errorMessage.easeOfSourcingError}
                                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                    helperText={errorMessage.easeOfSourcingError}
                                                                                                    label={t('reg.easeOfSourcing')}
                                                                                                    name="easeOfSourcing"
                                                                                                    onChange={(e) => handleChange(e)}>
                                                                                                    <MenuItem value="" disabled selected>Ease of sourcing</MenuItem>
                                                                                                    <MenuItem value="High">High</MenuItem>
                                                                                                    <MenuItem value="Medium">Medium</MenuItem>
                                                                                                    <MenuItem value="Low">Low</MenuItem>
                                                                                                </Select>
                                                                                            </FormControl>
                                                                                        </Tooltip>
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Typography variant="subtitle1" gutterBottom>{t('reg.sidingRequirement')}</Typography>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                            name="row-radio-buttons-group"
                                                                                        >
                                                                                            <FormControlLabel control={<Radio name="sidingRequirement" value="true" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.sidingRequirement === true} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                            <FormControlLabel control={<Radio name="sidingRequirement" value="false" disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} checked={landUpdatedDetails?.sidingRequirement === false} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />
                                                                                        </RadioGroup>
                                                                                    </Grid>
                                                                                    {landUpdatedDetails?.sidingRequirement === true ?
                                                                                        <Grid item xs={12}>
                                                                                            <Typography variant='caption' color="rgba(0, 0, 0, 0.6)" fontSize="2.4vh" gutterBottom >{t('reg.distanceInMetersForLoading')}</Typography>
                                                                                            <TextField fullWidth
                                                                                                required
                                                                                                disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)}
                                                                                                error={errorMessage.sidingDistanceInMtrsError}
                                                                                                helperText={errorMessage.sidingDistanceInMtrsError}
                                                                                                type="number"
                                                                                                onFocus={handleNumberFieldFocus}
                                                                                                label={t('reg.sidingDistance')}
                                                                                                name="sidingDistanceInMtrs"
                                                                                                defaultValue={landUpdatedDetails?.sidingDistanceInMtrs}
                                                                                                onChange={(e) => handleChange(e)} />
                                                                                        </Grid>
                                                                                        : null}
                                                                                    <Grid item xs={12}>
                                                                                        <LocationPointMUI
                                                                                            notRequired={true}
                                                                                            latitudeLabel="Latitude"
                                                                                            isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, true)}
                                                                                            longitudeLabel="Longitude"
                                                                                            latitudeName={t('preReg.latitude')}
                                                                                            longitudeName={t('preReg.longitude')}
                                                                                            latitude={landUpdatedDetails?.geocodeLattitude}
                                                                                            longitude={landUpdatedDetails?.geocodeLongitude}
                                                                                            callBackLocation={onLocationPoint}
                                                                                            latitudesError={errorMessage.latitudesError}
                                                                                            longitudesError={errorMessage.longitudesError}
                                                                                        />
                                                                                    </Grid>
                                                                                    <FileUploadMUI key="LandPics"
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, true)}
                                                                                        documentList={landUpdatedDetails?.growerCoopLandDocuments}
                                                                                        documentType="LandPics"
                                                                                        callBackDocumentUpload={onUploadCallBack}
                                                                                        stakeholderDetailId={growerDetails?.growers[0]?.growerLandDetails[0]?.id}
                                                                                        title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                                                                                        stakeHolderType="grower"
                                                                                        errorMessage={errorMessage}
                                                                                        setErrorMessage={setErrorMessage}
                                                                                        documentError="landPicError"
                                                                                    />
                                                                                    {/* <div className='mandatory_field'>{errorMessage.landPicError}</div> */}
                                                                                </Grid>
                                                                            </Grid>
                                                                            <Grid item xs={12} >
                                                                                <Accordion mt={1}>
                                                                                    <AccordionSummary
                                                                                        expandIcon={<AccordionIcon />}
                                                                                    >
                                                                                        <Typography variant="subtitle1" >Bamboo Species Details</Typography>
                                                                                    </AccordionSummary>
                                                                                    <AccordionDetails>
                                                                                        <Grid item xs={12}>
                                                                                            <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                                                                                                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                                                                                    {/* <Typography variant="h6" gutterBottom>
                                                    Bamboo Species Details
                                                </Typography> */}
                                                                                                </Stack>
                                                                                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                                                                                    <Button disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} onClick={(e) => addBamboo(e)} variant="contained" startIcon={<AddIcon />}>
                                                                                                        {t('reg.addBambooDetails')}
                                                                                                    </Button>
                                                                                                </Stack>
                                                                                            </Stack>
                                                                                            <DataGrid
                                                                                                sx={{
                                                                                                    "& .MuiDataGrid-columnHeaderTitle": {
                                                                                                        whiteSpace: "normal",
                                                                                                        lineHeight: "normal"
                                                                                                    },
                                                                                                    "& .MuiDataGrid-columnHeader": {
                                                                                                        height: "unset !important"
                                                                                                    },
                                                                                                    "& .MuiDataGrid-columnHeaders": {
                                                                                                        maxHeight: "168px !important"
                                                                                                    }
                                                                                                }}
                                                                                                autoHeight
                                                                                                rows={((landUpdatedDetails?.growerCoopBambooSpecies)?.filter(o1 => (bambooSpeciesRes)?.some(o2 => o1.bambooSpecies === o2.id & (o1.isActive === 1 || o1.isActive === 3))))}
                                                                                                pagination={false}
                                                                                                hideFooterPagination
                                                                                                columns={columns}
                                                                                                disableColumnMenu={true}
                                                                                                experimentalFeatures={{ newEditingApi: true }}
                                                                                                getRowId={(row) => row.bambooSpecies}
                                                                                            />
                                                                                        </Grid>
                                                                                    </AccordionDetails>
                                                                                </Accordion>
                                                                            </Grid>
                                                                        </Grid>
                                                                        {showCommentSection && <>
                                                                            <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                                                                <Grid item xs={7}>
                                                                                    <TextField sx={{ width: "100%" }}
                                                                                        label={t('reg.comment')}
                                                                                        name="comment"
                                                                                        inputProps={{
                                                                                            maxLength: 300,
                                                                                        }}
                                                                                        multiline
                                                                                        disabled={(selectedLand && !shouldActOnSectionLand[selectedLandId]) || viewOnly}
                                                                                        value={landComment}
                                                                                        onChange={(e) => setLandComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                                                                    />
                                                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                                                        <Badge bg={`${landComment?.length > characterLimit ? 'danger' : 'primary'}`}>{landComment?.length}/{characterLimit}</Badge>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                    <FormGroup>
                                                                                        <FormControlLabel control={<Switch disabled={selectedLand && !shouldActOnSectionLand[selectedLandId]} checked={landDetailsSectionOk[selectedLandId]}
                                                                                            onChange={(e) => setLandDetailsSectionOk({ ...landDetailsSectionOk, [selectedLandId]: e.target.checked })} />} label={<Typography variant="subtitle2" gutterBottom>
                                                                                                {t('reg.detailsOk')}?
                                                                                            </Typography>} />
                                                                                    </FormGroup>
                                                                                </Grid>
                                                                                <Grid item xs={3}>
                                                                                    <Button variant="contained" disabled={selectedLand && !shouldActOnSectionLand[selectedLandId]}
                                                                                        onClick={() => onSaveComment(landComment)}
                                                                                        startIcon={<CommentIcon />}
                                                                                    >
                                                                                        {t('preReg.addComment')}
                                                                                    </Button>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <div>
                                                                                <Accordion mt={1}>
                                                                                    <AccordionSummary
                                                                                        expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                                                    >
                                                                                        <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                                                    </AccordionSummary>
                                                                                    <AccordionDetails>
                                                                                        <Box style={{ height: 300, width: '100%' }}>
                                                                                            <DataGrid
                                                                                                rows={comments ? comments?.filter((item) => item.sectionName === "land_details" && item.sectionId === selectedLandId) : []}
                                                                                                columns={commentsColumn}
                                                                                                pageSize={10}
                                                                                                getRowHeight={() => 'auto'}
                                                                                            />
                                                                                        </Box>
                                                                                    </AccordionDetails>
                                                                                </Accordion>
                                                                            </div>
                                                                        </>}
                                                                        <Box display='flex' alignItems="center" justifyContent="center" mb={3} mt={2} style={{ float: "right" }}>
                                                                            {
                                                                                !showWorkFlowButtons &&
                                                                                <Button sx={{ minWidth: 100 }} variant="outlined" startIcon={<CloseIcon />} onClick={() => {
                                                                                    setOpen((prevOpen) => ({
                                                                                        ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false]))
                                                                                    }));
                                                                                    row.id == "noId" && setNewLandObject([])
                                                                                }}>Cancel</Button>}
                                                                            {
                                                                                (!showWorkFlowButtons || (localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid)) &&
                                                                                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" startIcon={addEditBtnName === t('reg.updateLand') ? <UpdateIcon /> : <AddIcon />}
                                                                                    disabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true, true)}
                                                                                    onClick={() => addLandBtnClick()}>{addEditBtnName}</Button>}
                                                                        </Box>
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>)}
                            <div className='mandatory_field'>{errorMessage.landCommentError}</div>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                <div className='mandatory_field'>{errorMessage.memberlandDetailsError}</div>
            </Grid >
            <Dialog maxWidth='md' fullWidth open={logModalOpen}>
                <DialogContent>
                    <BambooSpeciesPopover bambooSpeciesSubmitCallbackFunction={bambooSpeciesSubmitCallbackFunction} growerBambooSpeciesList={bambooSpecies?.growerBambooSpeciesList} growerBambooSpecies={updatedGrowerLandDetail?.growerCoopBambooSpecies} landDetailsId={updatedGrowerLandDetail.landDetailsId}
                        editSpecies={editSpecies} handleLogModalClose={handleLogModalClose} bambooSpeciesRes={bambooSpeciesRes}
                        isDisabled={!enableFieldFunction(shouldActOnSectionLand[selectedLandId], false, selectedLand ? false : true)} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default MemberLandDetails;
